import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/security/auth';
import user from './modules/security/user';
import account from './modules/security/account';
import security from './modules/security/security';
import environment from './modules/general/environment';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth, user, account, security, environment
  }
});


// WEBPACK FOOTER //
// ./src/store/store.js